import * as React from 'react'
import * as moment from 'moment'
import { JobNumberShape, ScanInfoData, ScanInfoEntry } from '../../api/api_data_types'
import { useScanInfoQuery } from '../../hooks/queries/case_plannings'
import ErrorMessage from '../job_plannings/list_app/ErrorMessage'

type ScanTabProps = {
  jobnumber: JobNumberShape
}

type ScanInfoGroupCardProps = {
  title: string
  entries: ScanInfoEntry[]
}

function formatSolution(entry: ScanInfoEntry) {
  const hasSolutionId = entry.losnings_id !== null && entry.losnings_id !== undefined
  const hasSolutionName = !!entry.losningsnavn

  if (hasSolutionId && hasSolutionName) {
    return `${entry.losnings_id} - ${entry.losningsnavn}`
  }

  if (hasSolutionName) {
    return entry.losningsnavn
  }

  if (hasSolutionId) {
    return String(entry.losnings_id)
  }

  return ''
}

function formatValue(value: string | number | null | undefined) {
  if (value === null || value === undefined || value === '') {
    return ''
  }

  return value
}

function ScanInfoGroupCard({ title, entries }: ScanInfoGroupCardProps) {
  const [isOpen, setIsOpen] = React.useState(false)

  return (
    <div className="card">
      <div className="card-header">
        <h2 className="mb-0">
          <button
            className="btn btn-link btn-block text-left"
            type="button"
            aria-expanded="true"
            onClick={() => setIsOpen(!isOpen)}
          >
            <span>{title}</span>
            <span className=""> ({entries.length})</span>
          </button>
        </h2>
      </div>
      <div className={`collapse ${isOpen ? 'show' : ''}`}>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-striped table-hover mb-0">
              <thead>
                <tr>
                  <th>Varenr</th>
                  <th>Varebeskrivelse</th>
                  <th>Løsning</th>
                  <th>Antal</th>
                  <th>Enhed</th>
                  <th>Afsluttet</th>
                  <th>Operator</th>
                  <th>Maskine</th>
                </tr>
              </thead>
              <tbody>
                {entries.map((entry) => (
                  <tr key={`${title}-${entry.losnings_id}-${entry.varenr}`}>
                    <td>{formatValue(entry.varenr)}</td>
                    <td>{formatValue(entry.varebeskrivelse)}</td>
                    <td>{formatSolution(entry)}</td>
                    <td>{formatValue(entry.antal)}</td>
                    <td>{formatValue(entry.enhed)}</td>
                    <td>{entry.afsluttet ? moment(entry.afsluttet).format('DD-MM-YYYY') : ''}</td>
                    <td>{formatValue(entry.operator)}</td>
                    <td>{formatValue(entry.machine)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default function ScanTab({ jobnumber }: ScanTabProps) {
  const { isLoading, isError, data, error } = useScanInfoQuery(jobnumber.id)
  const groupedEntries: ScanInfoData = data?.data || {}
  const processAreas = Object.keys(groupedEntries)

  if (isError) {
    return <ErrorMessage isError={isError} error={error} />
  }

  return (
    <div className="scan-tab">
      {isLoading && (
        <div className="text-center">
          <i className="fa fa-spinner fa-spin fa-2x" />
        </div>
      )}

      {!isLoading && processAreas.length === 0 && (
        <div className="text-center font-italic text-muted">Ingen scan fundet for denne ordre</div>
      )}

      {!isLoading && processAreas.length > 0 && (
        <div className="accordion">
          {processAreas.map((processArea) => (
            <ScanInfoGroupCard key={processArea} title={processArea} entries={groupedEntries[processArea]} />
          ))}
        </div>
      )}
    </div>
  )
}
